export const RAILWAY_URL = 'https://railway3.com/';
export const GOOGLE_DOCS_WHITEPAPER_URL =
  'https://drive.google.com/uc?export=download&id=1XRpiIByT3LmcjR0-FpLseT-4lM8ojdEW';
